export const version = "random/5.1.0";
//# sourceMappingURL=_version.js.map